import { format } from 'date-fns';

import { IDentalDependent } from 'models/request/dental/dependent';

export const DENTAL_INCLUSION_DEPENDENTS_URL =
  '/portal-conecta/inclusao-dependentes-odontologico';

export function mapDentalInclusionMotivo(optionId?: string): string {
  if (optionId === 'Exceção') {
    return 'União Estável';
  }

  return optionId || '';
}

export function resolveDentalEventDate(
  optionId?: string,
  dateEvent?: string,
): string {
  if (optionId === 'Outros') {
    return format(new Date(), 'dd/MM/yyyy');
  }

  return dateEvent || '';
}

export function mapDentalDependentPayload(
  dependent: IDentalDependent | undefined,
  dateEvent: string,
) {
  return {
    nomeDependente: dependent?.name,
    rgDependente: dependent?.rg,
    cpfDependente: dependent?.cpf,
    maeDependente: dependent?.mother,
    dataEvento: dateEvent,
    dtNascDependente: dependent?.dateBorn,
    grauParentesco: dependent?.type,
    sexoDependente: dependent?.genre,
    estadoCivil: dependent?.status,
    cartaoNacionalSaude: dependent?.cns,
  };
}
